<script setup lang="ts">
// Exalted's returns/claims are handled by wecare.exalted.com, not this native
// flow (used by other brands sharing this codebase). Anything still pointing
// at this route — bookmarks, old emails, search results — bounces straight
// to wecare's portal, pre-filled with the order code/email if present.
const route = useRoute()
const { buildWecareReturnUrl } = useWecarePortal()

const wecareUrl = buildWecareReturnUrl({
  orderCode: typeof route.query.code === 'string' ? route.query.code : undefined,
  email: typeof route.query.email === 'string' ? route.query.email : undefined,
})

if (wecareUrl)
  await navigateTo(wecareUrl, { external: true })
else
  await navigateTo('/')
</script>
